import { createReducer, on } from '@ngrx/store';
import { CustomerCard } from '../models/customer-card';
import * as ACTIONS from './cards.actions';

export const CARDS_FEATURE_KEY = 'cards';

export interface CardsState {
    customerCards: CustomerCard[];
    customerCardsLoaded: boolean;
}

export const CARDS_INITIAL_STATE: CardsState = {
    customerCards: null,
    customerCardsLoaded: false
};

export const cardsReducer = createReducer(
    CARDS_INITIAL_STATE,
    on(ACTIONS.fetchCustomerCards, (state) => ({ ...state, customerCardsLoaded: false })),
    on(ACTIONS.fetchCustomerCardsSuccess, (state, { customerCards }) => ({
        ...state,
        customerCards,
        customerCardsLoaded: true
    })),
    on(ACTIONS.fetchCustomerCardsFailed, (state) => ({ ...state, customerCardsLoaded: true }))
);
